import React from 'react';

const NoResults = ({ heading, preamble, query }) => {
    return (
        <div className='search-result-no-results '>
            <h2 className='headline-4 h-margin-bottom-1-important'>{heading} "{query}"</h2>
            <div dangerouslySetInnerHTML={{ __html: preamble }}></div>
        </div>
    );
};

export default NoResults;
